import React from 'react';
import { Link } from 'react-router-dom';
import { PRACTICE_INFO, SERVICES_DATA, DOCTORS_DATA } from '../../data/navigation';
import s from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={s.footer}>
      <div className="container">
        <div className={s.grid}>
          <div className={s.brand}>
            <div className={s.logo}>
              <div className={s.logoMark}>C</div>
              <span className={s.logoName}>Celebrity Smile Studio</span>
            </div>
            <div className={s.social}>
              <a href={PRACTICE_INFO.instagram} target="_blank" rel="noreferrer" className={s.socialBtn} title="Instagram">📸</a>
              <a href={PRACTICE_INFO.yelp} target="_blank" rel="noreferrer" className={s.socialBtn} title="Yelp">⭐</a>
              <a href={PRACTICE_INFO.google} target="_blank" rel="noreferrer" className={s.socialBtn} title="Google">🔍</a>
            </div>
          </div>

          <div className={s.col}>
            <h5>Services</h5>
            {SERVICES_DATA.slice(0,6).map(s2 => (
              <Link key={s2.slug} to={`/services/${s2.slug}`}>{s2.title}</Link>
            ))}
          </div>

          <div className={s.col}>
            <h5>Our Practice</h5>
            <Link to="/doctors">Doctors</Link>
            {DOCTORS_DATA.map(d => (
              <Link key={d.slug} to={`/about/${d.slug}`}>Dr. {d.name.split(' ').slice(1).join(' ')}</Link>
            ))}
            <Link to="/patient-center">Patient Information</Link>
            {/* <Link to="/patient-info/membership">Membership Plan</Link> 
            <Link to="/blog">Blog</Link> */}
          </div>

          <div className={s.col}>
            <h5>Contact</h5>
            <a href={PRACTICE_INFO.mapUrl} target="_blank" rel="noreferrer">{PRACTICE_INFO.address}</a>
            <a href={PRACTICE_INFO.mapUrl} target="_blank" rel="noreferrer">{PRACTICE_INFO.city}, {PRACTICE_INFO.state} {PRACTICE_INFO.zip}</a>
            <a href={`tel:${PRACTICE_INFO.phoneRaw}`}>{PRACTICE_INFO.phone}</a>
            <span style={{color:'rgba(255,255,255,.3)'}}>Fax: {PRACTICE_INFO.fax}</span>
            <Link to="/book-appointment" className={s.footerBook}>→ Book Appointment</Link>
          </div>
        </div>

        <div className={s.bottom}>
          <p>© Celebrity Smile Studio 2026. All Rights Reserved.</p>
          <p>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span> · </span>
            <Link to="/accessibility">Accessibility</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
